const ru = {

    // Navigation
    home: 'Главная',
    marketplace: 'Marketplace',
    products: 'Товары',
    login: 'Войти',
    logout: 'Выйти',
    register: 'Регистрация',
    myAccount: 'Мой аккаунт',
    adminPanel: 'Панель администратора',
    cart: 'Корзина',
    
    // Hero Section
    heroTitle: 'Цифровая платформа №1 в Карибском регионе',
    heroSubtitle: 'Покупайте подарочные карты, игровые пополнения, подписки и цифровые услуги с мгновенной доставкой',
    heroSlide2Title: 'Мгновенная цифровая доставка',
    heroSlide2Subtitle: 'Получайте коды сразу после оплаты',
    heroSlide3Title: 'Лучшие цены гарантированы',
    heroSlide3Subtitle: 'Самые выгодные цены на все цифровые товары',
    exploreProducts: 'Смотреть товары',
    shopNow: 'Купить сейчас',
    downloadApp: 'Скачать приложение',
    installApp: 'Установить',
    installAppHint: 'Чтобы установить: откройте меню Chrome (⋮) и нажмите «Установить приложение» или «Добавить на главный экран».',
    appInstalledToast: 'KayiCom установлено. Откройте его с главного экрана!',
    apkDownloadStarted: 'Загрузка APK. Откройте файл и нажмите «Установить».',
    appUpdateTitle: 'Доступно обновление',
    appUpdateMessage: 'Готова новая версия KayiCom. Обновите приложение, чтобы получить исправления и улучшения.',
    appUpdateLater: 'Позже',
    appUpdateNow: 'Обновить',
    appUpdateInstalling: 'Загрузка обновления…',
    appUpdatePermission: 'Разрешите KayiCom устанавливать обновления и повторите попытку.',
    appUpdateFailed: 'Не удалось обновить. Попробуйте снова.',
    appUpdateManualHint: 'Откройте эту страницу в Chrome, скачайте и установите новый APK KayiCom один раз. Дальнейшие обновления будут ставиться из приложения.',
    appUpdateVersionLine: 'У вас v{local} → v{remote}',
    appUpdatePlayProtectHint: 'Если Play Protect блокирует установку, выберите «Всё равно установить».',
    getStarted: 'Начать',
    
    // Features
    instantDelivery: 'Мгновенная доставка',
    instantDeliveryDesc: 'Коды за секунды',
    securePayment: 'Безопасная оплата',
    securePaymentDesc: 'Защищённые транзакции',
    support247: 'Поддержка 24/7',
    support247Desc: 'Помощь в любое время',
    competitivePrice: 'Выгодные цены',
    competitivePriceDesc: 'Лучшее соотношение цены и качества',
    
    // Homepage
    bestsellerLabel: 'Хиты продаж',
    bestSellingProducts: 'Самые продаваемые товары',
    categoryDeals: 'Горячие предложения',
    viewAll: 'Смотреть все',
    latestBlogPosts: 'Последние записи в Blog',
    visitBlog: 'Перейти в Blog',
    salesCount: 'продано',
    noProductsAvailable: 'Нет доступных товаров',
    totalProducts: 'Товары',
    totalSales: 'Продажи',
    totalCategories: 'Категории',

    // Blog
    blog: 'Blog',
    blogSubtitle: 'Руководства, новости и советы по цифровым товарам и стримингу',
    blogFeatured: 'Избранное',
    readMore: 'Читать далее',
    readArticle: 'Читать статью',
    backToBlog: 'Назад в Blog',
    loadingPosts: 'Загрузка записей...',
    loadingPost: 'Загрузка статьи...',
    noBlogPosts: 'Записей в Blog пока нет.',
    postNotFound: 'Эта статья недоступна.',
    minRead: 'мин чтения',
    relatedArticles: 'Похожие статьи',
    allArticles: 'Все статьи',

    // Products
    allProducts: 'Все товары',
    productsSubtitle: 'Найдите лучшие цифровые предложения мгновенно.',
    noProductsInCategory: 'В этой категории нет товаров',
    noProductsYet: 'Товаров пока нет.',
    showingResultsFor: 'Результаты по запросу',
    itemsCount: 'товаров',
    allCategories: 'Все',

    // Top-Up
    topupHeroTitle: 'Игровое пополнение',
    topupHeroSubtitle: 'Пополнение Free Fire LATAM и Delta Force — мгновенно на ваш аккаунт.',
    topupPlayerVerify: 'Проверка Player ID',
    topupPlayerVerifyDesc: 'Мы проверяем ваш ID перед доставкой',
    topupAutoDelivery: 'Автоматическая доставка',
    topupAutoDeliveryDesc: 'Кредиты за несколько минут',
    browseByGame: 'Выбрать по игре',
    allGames: 'Все игры',
    otherGames: 'Другие игры',
    howItWorks: 'Как это работает',
    topupStep1: 'Выберите игру и пакет',
    topupStep2: 'Выберите пакет и введите Player ID',
    topupStep3: 'Оплатите безопасно и получите мгновенно',
    topupIdDialogDesc: 'Введите игровой ID для продолжения. Он необходим для доставки.',
    topupSelectPackage: 'Выберите пакет',
    topupPackages: 'пакетов',
    topupBuy: 'Купить',
    topupOfficialBadge: 'Официальное пополнение',
    topupProductSubtitle: 'Выберите пакет и пополните аккаунт!',
    topupVerifyPlayerId: 'Проверить Player ID',
    topupSelected: 'Выбранный пакет',
    topupSearchGames: 'Поиск игр...',
    topupPopularGames: 'Популярные',
    topupSelectGame: 'Выберите игру',
    topupInstantBadge: 'Мгновенно',
    topupPopularSection: 'Популярные',
    topupDirectSection: 'Прямое пополнение',
    topupBestSellers: 'Лучшие предложения',
    topupBestSellerBadge: 'Хит',
    topupBrowseAll: 'Все пакеты',
    topupStepEnterId: 'Введите Player ID',
    topupSelectTopUp: 'Выберите пополнение',
    topupContinueCheckout: 'Перейти к оплате',
    topupViewAll: 'Показать все',
    topupTrending: 'В тренде',
    backToGames: 'Назад к играм',
    playerName: 'Имя игрока',
    fromPrice: 'От',
    noTopupPackages: 'Пакетов для этой игры пока нет.',
    viewGamePage: 'Открыть страницу игры',

    // Subscriptions
    subscriptionHeroTitle: 'Премиум-подписки',
    subscriptionHeroSubtitle: 'Netflix, Spotify, Disney+, YouTube Premium и другое — быстрая активация по выгодным ценам.',
    subscriptionInstantDesc: 'Доступ приходит в течение нескольких минут',
    subscriptionRenewLabel: 'Гибкие тарифы',
    subscriptionRenewDesc: 'Выберите подходящую длительность',
    subscriptionStep1: 'Выберите подписку и срок действия',
    subscriptionStep2: 'Оплатите безопасно удобным способом',
    subscriptionStep3: 'Получите данные для доступа и пользуйтесь',
    editPlayerId: 'Изменить Player ID',
    saveAndContinue: 'Сохранить и продолжить',
    playerIdRequired: 'Player ID обязателен',
    idSaved: 'ID сохранён',
    verifyingId: 'Проверка...',
    idVerified: 'ID подтверждён',
    floatingAnnouncementLabel: 'Уведомление',
    floatingAnnouncementDismiss: 'Понятно',

    // NatCash payment
    natcashPaymentTitle: 'Оплата NatCash',
    natcashAccountName: 'Имя аккаунта',
    natcashPhone: 'Номер NatCash',
    natcashAmount: 'Сумма к отправке',
    natcashReference: 'Код ссылки (указать в поле «Содержание»)',
    natcashWaitingPayment: 'Ожидание оплаты',
    natcashHowToPay: 'Как оплатить через NatCash:',
    natcashStep1: 'Наберите *202# на телефоне',
    natcashStep2: 'Выберите «Перевод»',
    natcashStep3: 'Введите точную сумму, указанную выше',
    natcashStep4: 'В поле «Содержание» введите код ссылки, указанный выше',
    natcashStep5: 'Введите PIN-код NatCash',
    natcashStep6: 'Нажмите «Отправить» для завершения оплаты',
    natcashPhoneWarning: 'Номер телефона, с которого вы отправляете, должен совпадать с номером, указанным при оформлении заказа.',
    natcashVerifyNow: 'ПРОВЕРИТЬ СЕЙЧАС',
    natcashSmsCountdown: 'Ожидание SMS',
    natcashAutoCheck: 'Система проверяет автоматически каждые 10 секунд',
    natcashAutoPayHint: 'Отправьте точную сумму и укажите код ссылки в Kontni — подтверждение автоматическое.',
    natcashVerifying: 'Проверка...',
    natcashCopy: 'КОПИРОВАТЬ',
    natcashCopied: 'Скопировано!',
    natcashAutoPayment: 'Автоматическая оплата — NatCash/Natcom',
    natcashTotalHtg: 'Итого NatCash (HTG)',
    paymentConfirmed: 'Оплата подтверждена!',
    paymentConfirmedPreparingDelivery: 'Оплата подтверждена. Мы готовим доставку. Откройте эту страницу снова, чтобы увидеть её.',
    autoDeliveryPendingHint: 'Заказ получен и обрабатывается. Подождите, пока мы завершим доставку.',

    transcodeLabel: 'Transcode',
    transcodePayHint: 'Оплатите точную сумму выше, затем вставьте Transcode из SMS о платеже ниже.',
    moncashPayHint: 'Оплатите точную сумму со своего номера MonCash (509 + 8 цифр) — подтверждение происходит автоматически по номеру и сумме, Transcode не нужен.',
    moncashOrderCreated: 'Заказ создан! Оплатите точную сумму со своего номера MonCash — подтверждение происходит автоматически по номеру и сумме.',
    moncashTopupCreated: 'Пополнение создано! Оплатите точную сумму со своего номера MonCash — подтверждение происходит автоматически по номеру и сумме.',
    transcodeSmsNote: 'После оплаты NatCash отправит SMS-подтверждение на ваш телефон. Transcode указан в этом сообщении — скопируйте его и вставьте в поле ниже.',
    transcodePlaceholder: 'напр. 26082105770513',
    transcodeEnterHint: 'Введите Transcode из SMS NatCash',
    transcodeVerify: 'Проверить сумму + Transcode',
    transcodeVerifying: 'Проверка суммы + Transcode…',
    transcodeApproved: 'Оплата подтверждена.',

    // MonCash payment
    moncashAutoPayment: 'Автоматическая оплата MonCash (HTG)',
    moncashMinPurchase: 'Минимальная покупка',
    moncashNeedMore: 'нужно ещё',
    moncashNeedMoreSuffix: '',
    moncashFee: 'Комиссия MonCash',
    natcashFee: 'Комиссия NatCash',
    htgPaymentFee: 'Комиссия платежа',
    moncashFeeOnOrder: 'по этому заказу',
    moncashMinimum: 'Минимум MonCash',
    moncashTotalWithFee: 'Итого с комиссией',
    moncashAmountToPay: 'К оплате в MonCash',
    moncashMerchantPhone: 'Номер MonCash',
    moncashPayerPhone: 'Номер, с которого нужно отправить',
    moncashToPay: 'К оплате',
    moncashPayWith: 'Оплатить через MonCash',
    moncashAutoConfirm: 'Автоматическое подтверждение после оплаты MonCash',
    moncashOpenPayment: 'Открыть оплату MonCash',
    moncashIPaidVerify: 'Я оплатил — Проверить',
    moncashChecking: 'Проверка…',
    moncashLinkMissing: 'Ссылка на оплату MonCash отсутствует',
    moncashVerifyFailed: 'Не удалось проверить оплату MonCash',
    moncashPaymentConfirmed: 'Оплата MonCash подтверждена!',
    moncashPaymentPending: 'Оплата всё ещё ожидает',
    moncashRedirecting: 'Перенаправление в MonCash...',
    moncashContinueOnTracking: 'Заказ создан! Продолжите оплату MonCash на странице отслеживания.',
    moncashMinPurchaseIs: 'Минимальная покупка MonCash —',
    moncashMinShort: 'Мин. MonCash',
    moncashOrderTotal: 'Сумма заказа',
    plopplopUssdOption: 'Оплата через USSD на телефоне MonCash — без страницы перенаправления',
    plopplopUssdHint: 'На ваш телефон отправлено USSD-приглашение MonCash. Подтвердите его, затем дождитесь автоматического подтверждения и доставки.',
    plopplopUssdNoPromptHint: 'USSD-приглашение не отправляется, если на e-money MonCash недостаточно средств или номер относится к NatCash.',
    plopplopUssdResend: 'Отправить USSD ещё раз',
    plopplopUssdResent: 'Запрошено новое USSD-приглашение MonCash. Подтвердите его на том же телефоне.',
    plopplopUssdResendFailed: 'Не удалось повторно отправить USSD-приглашение',
    ussdPayPageTitle: 'Оплата MonCash USSD',
    ussdPayPageHint: 'Нажмите Оплатить, чтобы отправить USSD. Система проверяет оплату автоматически. Можно также нажать Я оплатил.',
    ussdPayButton: 'Оплатить',
    ussdIPaidButton: 'Я оплатил',
    ussdTxnFromSms: 'Номер транзакции MonCash из SMS',
    ussdTxnFromSmsHint: 'Если «Я оплатил» не находит платёж, введите номер транзакции из SMS MonCash и нажмите снова.',
    ussdPaySent: 'USSD отправлен. Подтвердите его на телефоне MonCash.',
    ussdPayWaiting: 'Ожидание автоматического подтверждения…',
    plopplopPhoneLabel: 'Номер телефона MonCash',
    plopplopPhoneRequired: 'Введите действительный номер MonCash (39308318)',
    plopplopRedirectHint: 'Завершите оплату на защищённой странице. Этот экран обновится автоматически, затем заказ будет доставлен.',
    plopplopCardTitle: 'Дебетовая / кредитная карта',
    plopplopCardDesc: 'Оплата картой (USD). Мы отправим ваши данные автоматически.',
    plopplopCardHint: 'Завершите оплату картой. Сумма списывается в USD. Экран обновится автоматически, затем заказ будет доставлен.',
    plopplopCardRedirecting: 'Перенаправление на оплату картой (USD)…',
    plopplopOpenCardPayment: 'Продолжить оплату картой',
    plopplopOpenHostedPayment: 'Продолжить оплату',
    plopplopPaymentExpired: 'Этот платёж истёк через 10 минут. Оформите новый заказ, чтобы оплатить.',
    plopplopCardAmountHtg: 'Итого картой (USD)',
    plopplopCardFee: 'Комиссия карты',
    plopplopCardPayUsd: 'Списание в USD',
    plopplopCardAutoConfirm: 'Оплата подтверждается автоматически после платежа.',
    paymentDescription: 'Описание оплаты',
    playerFound: 'Игрок найден',
    
    // Categories
    categoryTitle: 'Категории товаров',
    giftCards: 'Подарочные карты',
    gameTopup: 'Игровое пополнение',
    subscriptions: 'Подписки',
    services: 'Услуги',
    crypto: 'Крипто',
    
    // What We Offer
    whatWeOffer: 'Что мы предлагаем',
    offerSubtitle: 'Выбирайте из множества категорий цифровых товаров с мгновенной доставкой',
    internationalGiftCards: 'Международные подарочные карты',
    giftCardsDesc: 'Amazon, Google Play, iTunes, Steam и другие',
    automaticGameTopup: 'Автоматическое игровое пополнение',
    gameTopupDesc: 'Free Fire LATAM и Delta Force — мгновенная доставка',
    premiumSubscriptions: 'Премиум-подписки',
    subscriptionsDesc: 'Netflix, Spotify, Disney+ и другие сервисы',
    digitalServices: 'Цифровые услуги',
    servicesDesc: 'Создание аккаунта Stripe, верификация PayPal, TextNow',
    
    // Featured Products
    featuredProducts: 'Рекомендуемые товары',
    buyNow: 'Купить сейчас',
    addToCart: 'В корзину',
    viewDetails: 'Подробнее',
    available: 'В наличии',
    outOfStock: 'Нет в наличии',
    
    // Ready to Start
    readyToStart: 'Готовы начать?',
    
    // Auth
    email: 'Email',
    password: 'Пароль',
    fullName: 'Полное имя',
    confirmPassword: 'Подтвердите пароль',
    dontHaveAccount: 'Нет аккаунта?',
    alreadyHaveAccount: 'Уже есть аккаунт?',
    createAccount: 'Создать аккаунт',
    gmailYahooOnly: 'Для регистрации используйте адрес Gmail или Yahoo.',
    verifyEmailSent: 'Аккаунт создан. Проверьте почту и подтвердите её, чтобы продолжить.',
    verifyEmailToContinue: 'Подтвердите почту, чтобы продолжить. Мы отправили ссылку.',
    verifyEmailTitle: 'Подтвердите почту',
    verifyEmailMissingToken: 'Откройте ссылку из письма или отправьте её снова.',
    verifyEmailBanner: 'Подтвердите почту, чтобы сделать первый заказ.',
    resendVerification: 'Отправить письмо ещё раз',
    rememberMe: 'Запомнить меня',
    showPassword: 'Показать пароль',
    hidePassword: 'Скрыть пароль',
    forgotPassword: 'Забыли пароль?',
    orContinueWith: 'или продолжить через',
    continueWithGoogle: 'Войти через Google',
    continueWithTelegram: 'Войти через Telegram',
    socialLoginStateInvalid: 'Сессия соцвхода истекла. Попробуйте снова.',
    resetPassword: 'Сбросить пароль',
    sendResetLink: 'Отправить ссылку для сброса',
    backToLogin: 'Вернуться ко входу',
    newPassword: 'Новый пароль',
    confirmNewPassword: 'Подтвердите новый пароль',
    passwordsDoNotMatch: 'Пароли не совпадают',
    resetLinkSent: 'Если email существует, ссылка для сброса отправлена.',
    resetSuccess: 'Пароль успешно сброшен. Войдите в аккаунт.',
    tokenMissing: 'Токен сброса отсутствует или недействителен.',
    
    // Cart & Checkout
    yourCart: 'Ваша корзина',
    emptyCart: 'Корзина пуста',
    continueShopping: 'Продолжить покупки',
    orderSummary: 'Итого по заказу',
    subtotal: 'Подытог',
    total: 'Итого',
    items: 'товаров',
    checkout: 'Оформить заказ',
    placeOrder: 'Разместить заказ',
    
    // Payment
    paymentMethod: 'Способ оплаты',
    cryptocurrency: 'Криптовалюта (автоматически)',
    manualPayment: 'Ручная оплата',
    cryptoDesc: 'Bitcoin, Ethereum и другие',
    manualDesc: 'Банковский перевод, другие способы (требуется подтверждение)',
    
    // Order Tracking
    orderTracking: 'Отслеживание заказа',
    orderNumber: 'Заказ',
    orderStatus: 'Статус заказа',
    paymentStatus: 'Статус оплаты',
    orderItems: 'Товары в заказе',
    submitProof: 'Отправить подтверждение оплаты',
    transactionId: 'ID транзакции',
    proofUrl: 'URL подтверждения',
    uploadProof: 'Загрузить подтверждение',
    
    // Dashboard
    dashboard: 'Панель управления',
    myOrders: 'Мои заказы',
    totalOrders: 'Всего заказов',
    pendingOrders: 'Ожидающие заказы',
    completedOrders: 'Выполненные заказы',
    noOrders: 'У вас пока нет заказов',
    
    // Admin
    manageProducts: 'Управление товарами',
    manageOrders: 'Управление заказами',
    siteSettings: 'Настройки сайта',
    addProduct: 'Добавить товар',
    editProduct: 'Редактировать товар',
    deleteProduct: 'Удалить товар',
    productName: 'Название товара',
    description: 'Описание',
    category: 'Категория',
    price: 'Цена',
    currency: 'Валюта',
    imageUrl: 'URL изображения',
    stockAvailable: 'Наличие на складе',
    deliveryType: 'Тип доставки',
    automatic: 'Автоматически',
    manual: 'Вручную',
    save: 'Сохранить',
    cancel: 'Отмена',
    
    // Settings
    general: 'Общие',
    apiKeys: 'API-ключи',
    appearance: 'Внешний вид',
    siteName: 'Название сайта',
    supportEmail: 'Email поддержки',
    logoUrl: 'URL логотипа',
    primaryColor: 'Основной цвет',
    secondaryColor: 'Дополнительный цвет',
    saveSettings: 'Сохранить настройки',
    
    // Footer
    aboutUs: 'О нас',
    contact: 'Контакты',
    footerCompany: 'Компания',
    footerCategories: 'Категории',
    footerSocial: 'Соцсети',
    footerBlogs: 'Блог',
    footerTagline: 'Подарочные карты, пополнения игр, подписки и цифровые услуги с быстрой доставкой.',
    footerSocialComingSoon: 'Скоро в соцсетях.',
    quickLinks: 'Быстрые ссылки',
    support: 'Поддержка',
    refundPolicy: 'Политика возврата',
    privacyPolicy: 'Политика конфиденциальности',
    allRightsReserved: 'Все права защищены',
    
    // Messages
    loading: 'Загрузка...',
    processing: 'Обработка...',
    success: 'Успешно!',
    error: 'Ошибка',
    loginSuccess: 'Вход выполнен успешно!',
    logoutSuccess: 'Выход выполнен успешно!',
    productAdded: 'Товар добавлен в корзину',
    productRemoved: 'Товар удалён из корзины',
    orderPlaced: 'Заказ успешно оформлен!',
    proofSubmitted: 'Подтверждение оплаты успешно отправлено!',
};

export default ru;
